import { IThemeModel } from "../models/IThemeModel";

//@ts-ignore sort-keys
export const ggdTheme: IThemeModel = {
    primaryColor: "red",
    secondaryColor: "black",

    // borders
    borderNeutral: "orange",
    borderContentSeperator: "hotpink",

    // text colors
    primaryTextColor: "#616161",
    primaryNavigationTextColor: "green",

    //header
    headerBackgroundColor: "yellow"
};
